import React from 'react';
import type { TeamMember } from '../../types/conditions';
interface AvatarProps {
  member: TeamMember;
  size?: 'sm' | 'md';
}
export function Avatar({
  member,
  size = 'md'
}: AvatarProps) {
  const dims = size === 'sm' ? 'h-6 w-6 text-[10px]' : 'h-8 w-8 text-xs';
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white ${dims}`} style={{
    backgroundColor: member.color
  }} title={`${member.name} · ${member.role}`} data-id="element-74" data-mp="2egfksrfd5up">
      {member.initials}
    </span>;
}